import type { GccDispositionTag } from './types'

/**
 * Every Step 1 AI disposition, ordered from most to least work removed (WI 2323).
 * Shared so the pipeline and the dashboard agree on the set and its order.
 */
export const GCC_DISPOSITIONS: readonly GccDispositionTag[] = ['Eliminate', 'Agentify', 'Automate', 'Augment', 'Human']

/** True when the value is one of the five dispositions (LLM output is untrusted). */
export function isGccDisposition(value: unknown): value is GccDispositionTag {
  return typeof value === 'string' && (GCC_DISPOSITIONS as readonly string[]).includes(value)
}
